import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SharedFacade,
  ProjectsFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
  getRolesAndPermission,
} from '@piqet-angular/data';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ProjectPackEOLDataGridService } from './project-scenario-eol-data-grid.service';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  CustomModalService,
  EOLEntrySource,
  FeatureCodes,
  mainModuleName,
  reportTitals,
  rolesModuleName,
  StorageTypeEnum,
  UPDATE_SCENARIO_EOL,
  UPDATE_SCENARIO_EOL_TITLE,
} from '@piqet-angular/shared';
import {
  Subscription,
  catchError,
  combineLatest,
  finalize,
  lastValueFrom,
  map,
  of,
  switchMap,
  take,
} from 'rxjs';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from 'libs/ui/src/lib/inline-action-button/inline-action-button.component';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { GridCellRendererComponent } from 'libs/ui/src/lib/grid-cell-renderer/grid-cell-renderer.component';
import { recycledContent, eolGuidedTourStepStr } from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { JoyrideService } from 'ngx-joyride';
@Component({
  selector: 'piqet-angular-project-scenario-eol',
  templateUrl: './project-scenario-eol.component.html',
  styleUrls: ['./project-scenario-eol.component.scss'],
})
export class ProjectScenarioEOLComponent {
  recycledContentDropdownData = recycledContent;
  FeatureCodes = FeatureCodes;
  StorageTypeEnum = StorageTypeEnum;
  eolGTStepStr = eolGuidedTourStepStr;
  reportResource = reportTitals;
  headerData = 'End-of-life';
  columnDefsPostretail: ColDef[];
  columnDefsPreretail: ColDef[];
  columnDefsRetail: ColDef[];
  columnDefsConsumer: ColDef[];
  colDefsCustomFate: ColDef[];
  activatedRouteProjectId: any;
  projectPostRetailPackEolDataPayload: any;
  activatedRoute: any;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
    NumericCellEditor: NumericCellEditor,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  scenarioId: any;
  eId: any;
  event: any;
  packageScenarioId: any;
  iSGuideTour: boolean = false;
  preRetailData: any;
  postRetailData: any;
  customWasteDetail: any;
  customWasteScenarioCountry: any = [];
  retailCustomWasteScenarioId: number | null = null;
  consumerCustomWasteScenarioId: number | null = null;
  eolFormGroup!: FormGroup;
  retailCountryList: any = [];
  consumerCountryList: any = [];
  recycledContentGridData: any;
  isShowRetailNotification: boolean = false;
  isShowConsumerNotification: boolean = false;
  customRetailCountry: any;
  customConsumerCountry: any;
  consumerEOLCountryId: any;
  retailEOLCountryId: any;
  recycledContentGridConsumer: any;
  selectRegion: any;
  retailEOLGridData: any;
  consumerEOLGridData: any;
  errorStr: any;
  errForConsumer: any;
  isProjectLocked!: boolean;
  backRouteType: any;
  navigationConfig: any;
  menuDataForRouting: any;
  subscriptions: Subscription[] = [];
  activeIdsMain: any = ['panel1'];
  isCustomRetailEol: boolean = false;
  isCustomConsumerEol: boolean = false;
  customEolRetailList: any;
  customEolConsumerList: any;
  retailType = 'retail';
  consumerType = 'consumer';
  showCustomWasteAccess: boolean = false;
  endOfLifeRegionMessage =
    'Your custom end-of-life region was not included in the list of countries selected in Project Settings. Please adjust accordingly.';
  showEdit: boolean = false;
  showIncorrectEOLNotification = false;

  incorrectValueMessage = 'EOL rates are outdated. Update to regional defaults or edit manually.';
  incorrectBtnName = 'Auto update';

  constructor(
    private projectPackEOLDataGridService: ProjectPackEOLDataGridService,
    private viewportScroller: ViewportScroller,
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private projectsService: ProjectsService,
    private customService: CustomService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private toaster: ToastrService,
    private sharedService: SharedService,
    private swalService: SwalService,
    private accessService: AccessPermissionService,
    public joyrideService: JoyrideService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.showCustomWasteAccess = getRolesAndPermission(
      rolesModuleName.customWasteScenario,
      mainModuleName.customModule
    )?.isOverview;
    this.route.queryParams.subscribe(async (values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.eId = value['eId'];
      this.packageScenarioId = value['packageScenarioId'];
      this.iSGuideTour = value['haveTour'];
      const url = location.href.split('/');
      this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
      await this.getAllEolData();
    });
    this.columnDefsPreretail =
      this.projectPackEOLDataGridService.getProjectPreReatilPackEOLDataColumn();
    this.columnDefsRetail = this.projectPackEOLDataGridService.getProjectRetailEOLDataColumn();
    this.columnDefsConsumer = this.projectPackEOLDataGridService.getProjectRetailEOLDataColumn();
    this.showEdit && (this.columnDefsConsumer[18].cellRendererParams.gridType = 'isConsumer');
    this.columnDefsPostretail =
      this.projectPackEOLDataGridService.getProjectPostReatilPackEOLDataColumn();
    this.colDefsCustomFate = this.projectPackEOLDataGridService.getComponentGridData();

    this.subscriptions.push(
      this.projectPackEOLDataGridService.editPreRetailSuccessData$.subscribe(async () => {
        this.getPreRetailList();
      }),

      this.projectPackEOLDataGridService.updateNotificationSub$
        .pipe(
          take(1),
          switchMap(() =>
            combineLatest([
              this.projectFacade.packageEOLRetail$,
              this.projectFacade.packageEOLConsumer$,
            ]).pipe(
              map(([retailData, consumerData]) => {
                const isRetailInvalid = this.hasInvalidTotals(retailData);
                const isConsumerInvalid = this.hasInvalidTotals(consumerData);
                return isRetailInvalid || isConsumerInvalid;
              })
            )
          )
        )
        .subscribe(hasAnyInvalid => {
          this.showIncorrectEOLNotification = hasAnyInvalid;
        }),
      this.projectPackEOLDataGridService.editPostRetailSuccessData$.subscribe(async () => {
        this.getPostRetailList();
      }),
      this.projectPackEOLDataGridService.deletePackageEOLData$.subscribe(async deleteData => {
        this.deletePackageEOLProject(deleteData[0], deleteData[1]);
      }),
      this.sharedService.showCalcErrObs$.subscribe((data: any) => {
        this.errorStr = data[0];
        this.errForConsumer = data[1];
        if (this.errorStr) this.deleteConfirmation();
      }),
      this.sharedService.menuData$.subscribe((res: any) => {
        this.menuDataForRouting = res;
      }),
      this.projectPackEOLDataGridService.inlineEditTripsObs$.subscribe(async data => {
        this.updateNoOfTrips(data);
      })
    );
  }

  hasInvalidTotals(data: any[]): boolean {
    const percentageFields = [
      'landfill',
      'recycling',
      'homeComposting',
      'incineration',
      'wasteEnergyRecovery',
      'openDump',
      'anerobicDigestion',
      'litter',
      'stormWater',
      'sewer',
      'commercialComposting',
      'recyclingOpenLoop',
      'chemicalRecycling',
      'pyrolysis',
      'openBurning',
      'none',
    ];

    return data.some(item => {
      const total = percentageFields.reduce((sum, field) => {
        return sum + (item[field] || 0);
      }, 0);

      return Math.round(total * 100) / 100 !== 100;
    });
  }

  async ngOnInit(): Promise<void> {
    !this.joyrideService.isTourInProgress() && this.viewportScroller.scrollToPosition([0, 0]);
    this.eolFormGroup = this.formBuilder.group({
      country: [null],
      countryConsumer: [null],
    });
  }

  getCustomEolValue(type: string) {
    return type === this.retailType ? this.isCustomRetailEol : this.isCustomConsumerEol;
  }

  getCustomEolSelectedId(type: string): number | null {
    const id =
      type === this.retailType
        ? this.retailCustomWasteScenarioId
        : this.consumerCustomWasteScenarioId;
    return id === 0 ? null : id;
  }

  getCustomEolList(type: string) {
    return this.customEolRetailList;
  }

  async changEolValue(data: any, type: string) {
    const isRetail = type === this.retailType;
    if (isRetail) {
      this.retailCustomWasteScenarioId = 0;
      this.isCustomRetailEol = data.target.checked;
      if (
        !data.target.checked &&
        this.retailCountryList.some((x: any) => x.id == this.customRetailCountry?.id)
      ) {
        this.retailCountryList = this.retailCountryList.filter(
          (item: any) => item.id !== this.customRetailCountry.id
        );
        this.customRetailCountry = null;
        this.isShowRetailNotification = false;
      }
      this.eolFormGroup.patchValue({
        country: this.retailEOLCountryId || this.retailCountryList[0].id,
      });
    } else {
      this.consumerCustomWasteScenarioId = 0;
      this.isCustomConsumerEol = data.target.checked;
      if (
        !data.target.checked &&
        this.consumerCountryList.some((x: any) => x.id == this.customConsumerCountry?.id)
      ) {
        this.consumerCountryList = this.consumerCountryList.filter(
          (item: any) => item.id !== this.customConsumerCountry.id
        );
        this.customConsumerCountry = null;
        this.isShowConsumerNotification = false;
      }
      this.eolFormGroup.patchValue({
        countryConsumer: this.consumerEOLCountryId || this.consumerCountryList[0].id,
      });
    }
    await this.updateEolGridData(isRetail, 0, EOLEntrySource.Custom);
  }

  async changeEolRetail(eve: any, type: string) {
    const isRetail = type === this.retailType;
    await this.updateEolGridData(isRetail, eve?.wasteScenarioId, EOLEntrySource.Custom);
  }

  private async updateEolGridData(
    isRetail: boolean,
    wasteScenarioId: number,
    EOLSourceType: any = EOLEntrySource.System
  ) {
    const countryId = isRetail ? this.retailEOLCountryId : this.consumerEOLCountryId;
    const eolType = isRetail ? this.StorageTypeEnum.Retail : this.StorageTypeEnum.Consumer;

    const response = await this.projectsService.getEolLifeListAsync(
      0,
      this.scenarioId,
      countryId,
      wasteScenarioId,
      eolType,
      false,
      EOLSourceType
    );
    if (isRetail) {
      this.retailEOLGridData = response.data?.eolDetails;
      this.retailCountryList = this.retailCountryList.filter(
        (item: any) => item.id !== this.customRetailCountry?.id
      );
      this.customRetailCountry = null;
      this.isShowRetailNotification = false;
      this.eolFormGroup.patchValue({
        country: this.retailEOLCountryId || this.retailCountryList[0].id,
      });
      if (
        response.data?.wasteScenarioCountry &&
        !this.retailCountryList.some((x: any) => x.id == response.data?.wasteScenarioCountry?.id)
      ) {
        this.customRetailCountry = response.data?.wasteScenarioCountry;
        this.retailCountryList.push(response.data?.wasteScenarioCountry);
        this.isShowRetailNotification = true;
        this.retailCountryList = [...this.retailCountryList];
      }
      response.data?.wasteScenarioCountry &&
        this.eolFormGroup.patchValue({ country: response.data?.wasteScenarioCountry?.id });
      this.projectFacade.patchEOLRetailList(this.retailEOLGridData);
    } else {
      this.consumerEOLGridData = response.data?.eolDetails;
      this.consumerCountryList = this.consumerCountryList.filter(
        (item: any) => item.id !== this.customConsumerCountry?.id
      );
      this.customConsumerCountry = null;
      this.isShowConsumerNotification = false;
      this.eolFormGroup.patchValue({
        countryConsumer: this.consumerEOLCountryId || this.consumerCountryList[0].id,
      });
      if (
        response.data?.wasteScenarioCountry &&
        !this.consumerCountryList.some((x: any) => x.id == response.data?.wasteScenarioCountry?.id)
      ) {
        this.customConsumerCountry = response.data?.wasteScenarioCountry;
        this.consumerCountryList.push(this.customConsumerCountry);
        this.isShowConsumerNotification = true;
        this.consumerCountryList = [...this.consumerCountryList];
      }
      response.data?.wasteScenarioCountry &&
        this.eolFormGroup.patchValue({ countryConsumer: response.data?.wasteScenarioCountry?.id });
      this.projectFacade.patchEOLConsumerList(this.consumerEOLGridData);
    }
  }

  async getAllEolData() {
    const payload = {
      projectId: this.activatedRouteProjectId,
      scenarioId: this.packageScenarioId,
      packageScenarioId: this.scenarioId,
    };

    const response = await this.projectsService.getAllEolDetails(payload).toPromise();
    if (response?.data) {
      response?.data?.reuseFillingData &&
        response?.data?.reuseFillingData?.map((item: any) => {
          item.fillingTransportDetail.map((data: any) => {
            data['cityName'] = data.originName;
          });
        });
      this.preRetailData = response?.data.reuseFillingData;
      this.postRetailData = response?.data.reuseFillingData;
      this.customWasteDetail = response?.data.customWasteDetail;

      this.consumerCustomWasteScenarioId = this.customWasteDetail?.consumerCustomWasteScenarioId;
      this.retailCustomWasteScenarioId = this.customWasteDetail?.retailCustomWasteScenarioId;
      this.customEolRetailList = this.customWasteDetail?.customwasteScenarioItems;
      this.customEolConsumerList = this.customWasteDetail?.customwasteScenarioItems;
      this.recycledContentGridData = response.data?.eolComponentList?.retailComponentList;
      this.retailEOLCountryId = response.data?.eolComponentList?.retailEOLCountryId;
      this.consumerEOLCountryId = response.data?.eolComponentList?.consumerEOLCountryId;
      this.recycledContentGridConsumer = response.data?.eolComponentList?.consumerComponentList;
      this.isProjectLocked = response.data?.eolComponentList?.isLockProject;
      this.navigationConfig = {
        scenarioId: this.scenarioId,
        packageScenarioId: this.packageScenarioId,
        eId: this.eId,
        activatedRouteProjectId: this.activatedRouteProjectId,
        activatedRoute: this.activatedRoute,
        isProjectLocked: this.isProjectLocked,
        isProductPage: true,
      };
      this.retailCountryList = response.data?.projectRegionList;
      this.consumerCountryList = response.data?.projectRegionList;
      this.consumerEOLGridData = response.data?.consumerEOLList;
      this.retailEOLGridData = response.data?.retailEOLList;
      this.projectFacade.patchEOLRetailList(this.retailEOLGridData);
      this.projectFacade.patchEOLConsumerList(this.consumerEOLGridData);
      this.isCustomRetailEol =
        this.customWasteDetail?.retailCustomWasteScenarioId > 0 ? true : false;
      this.isCustomConsumerEol =
        this.customWasteDetail?.consumerCustomWasteScenarioId > 0 ? true : false;
      this.customWasteScenarioCountry = this.customWasteDetail?.customWasteScenarioCountry || [];
      this.showIncorrectEOLNotification = response.data?.invalidEOLRates;

      if (this.customWasteScenarioCountry.length) {
        this.customConsumerCountry = this.customWasteScenarioCountry.find(
          (item: any) => item.parentId == StorageTypeEnum.Consumer
        );
        this.customRetailCountry = this.customWasteScenarioCountry.find(
          (item: any) => item.parentId == StorageTypeEnum.Retail
        );

        if (
          this.customRetailCountry &&
          !this.retailCountryList.some((x: any) => x.id == this.customRetailCountry?.id)
        ) {
          this.retailCountryList.push(this.customRetailCountry);
          this.isShowRetailNotification = true;
          this.eolFormGroup.patchValue({
            country: this.customRetailCountry.id || this.retailCountryList[0].id,
          });
        }

        if (
          this.customConsumerCountry &&
          !this.consumerCountryList.some((x: any) => x.id == this.customConsumerCountry?.id)
        ) {
          this.consumerCountryList.push(this.customConsumerCountry);
          this.isShowConsumerNotification = true;
          this.eolFormGroup.patchValue({
            countryConsumer: this.customConsumerCountry.id || this.consumerCountryList[0].id,
          });
        }
      }
      this.getCustomEolList(this.retailType);
      this.setFormValue();
    }
  }

  deleteConfirmation() {
    this.swalService
      .confirm('Warning', 'End-of-life data is required to equal 100%', '', true)
      .then(confirmed => {});
  }

  updateNoOfTrips(data: any) {
    this.projectsService.updateNoOfTripsDataEOL(data).subscribe(res => {
      res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      this.getPreRetailList();
    });
  }

  setFormValue() {
    this.eolFormGroup.patchValue({
      country: this.retailEOLCountryId || this.retailCountryList[0].id,
      countryConsumer: this.consumerEOLCountryId || this.consumerCountryList[0].id,
    });
    // this.getEOLGridValues(this.retailEOLCountryId || this.countryList[0].id, false);
    // this.getEOLGridValues(this.consumerEOLCountryId || this.countryList[0].id, true);
  }

  changeCountry(event: any) {
    if (!event.id) return;
    this.getEOLGridValues(event.id, false, false, EOLEntrySource.System);
  }

  changeCountryConsumer(event: any) {
    if (!event.id) return;
    this.getEOLGridValues(event.id, true, false, EOLEntrySource.System);
  }

  async refreshCustomWasteScenario(type: any) {
    const customEolList = await this.customService.getAllCustomWasteScenarioList().toPromise();
    this.customEolRetailList = customEolList?.data;
    this.customEolConsumerList = customEolList?.data;
    if (type === this.retailType) {
      this.retailCustomWasteScenarioId = 0;
    } else {
      this.consumerCustomWasteScenarioId = 0;
    }
    this.getCustomEolSelectedId(type);
  }

  async getPreRetailList() {
    const preRetailData = (
      await this.projectsService.getProjectEOLRetailAsync(this.packageScenarioId)
    )?.data;
    preRetailData?.map((item: any) => {
      item.fillingTransportDetail.map((data: any) => {
        data['cityName'] = data.originName;
      });
    });
    this.preRetailData = preRetailData;
  }

  async getRecycledContentData() {
    const response = await lastValueFrom(this.projectsService.getEOLComponentList(this.scenarioId));
    this.recycledContentGridData = response.data?.retailComponentList;
    this.retailEOLCountryId = response.data?.retailEOLCountryId;
    this.consumerEOLCountryId = response.data?.consumerEOLCountryId;
    this.recycledContentGridConsumer = response.data?.consumerComponentList;
    this.isProjectLocked = response.data?.isLockProject;
    this.showIncorrectEOLNotification = response.data?.invalidEOLRates;
  }

  onNext() {
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.sharedService.accessSideBarData('charts');
    let valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.scenarioId} }`;
    const encryptedValue = encrypt(valueToEncrypt);
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/chart-at-glance`],
      { queryParams: { encryptedValue } }
    );
  }

  async getEOLGridValues(
    regionId?: any,
    isConsumer?: boolean,
    isCreate: boolean = true,
    EolSourceType: any = EOLEntrySource.System
  ) {
    const region = regionId || this.selectRegion?.id;
    if (isConsumer) {
      this.consumerEOLGridData = (
        await this.projectsService.getEolLifeListAsync(
          0,
          this.scenarioId,
          region,
          0,
          3,
          isCreate,
          EolSourceType
        )
      ).data?.eolDetails;
      this.consumerEOLCountryId = region;
      this.projectFacade.patchEOLConsumerList(this.consumerEOLGridData);
    } else {
      this.retailEOLGridData = (
        await this.projectsService.getEolLifeListAsync(
          0,
          this.scenarioId,
          region,
          0,
          2,
          isCreate,
          EolSourceType
        )
      ).data?.eolDetails;
      this.retailEOLCountryId = region;
      this.projectFacade.patchEOLRetailList(this.retailEOLGridData);
    }
  }

  async getPostRetailList() {
    this.postRetailData = (
      await this.projectsService.getProjectEOLConsumerAsync(this.packageScenarioId)
    )?.data;
  }

  async addPreRetail(newEolPreRetailData: any, id: any, actionLabel: any, pathName: any) {
    let response = await this.projectsService.openAddEditPreRetailForasync(
      this.packageScenarioId,
      '0',
      this.StorageTypeEnum.Retail
    );
    this.modal.invoke('newEolPreRetail', {
      initialState: {
        newEolPreRetailData: response.data,
        locationProcessDef:
          this.projectPackEOLDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectPackEOLDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportDef: this.projectPackEOLDataGridService.getCustomTransportItemsList(),
        ingredientTransportColumnDef:
          this.projectPackEOLDataGridService.newPreRetailTransportColumns(),
        columnDefsPreretailCost:
          this.projectPackEOLDataGridService.newPreRetailTransportColumnsCost(),
        reuseColumnDef: this.projectPackEOLDataGridService.reuseColumns(),
        label: actionLabel,
        pathName: pathName,
        scenarioId: response.data.scenarioId,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewPreRetailEvent.subscribe((saveNewPreRetailEvent: any) => {
      this.editPackageEOL(saveNewPreRetailEvent, this.packageScenarioId, pathName);
    });
  }

  editPackageEOL(data: any, packageScenarioId: any, pathName: any) {
    if (pathName == 'preRetail') {
      this.projectsService
        .addEditEolPreRetail(data.mainPayload)
        .pipe(
          catchError((error: any) =>
            of(this.toaster.error('An error occurred. Please try again later.'))
          ),
          finalize(() => {
            this.modal.close();
            this.getPreRetailList();
          })
        )
        .subscribe(res => {
          res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
          this.projectFacade.clearEolPreReatil();
        });
    } else {
      this.projectsService
        .addEditEolPostRetail(data.mainPayload)
        .pipe(
          catchError((error: any) =>
            of(this.toaster.error('An error occurred. Please try again later.'))
          ),
          finalize(() => {
            this.modal.close();
            this.getPostRetailList();
          })
        )
        .subscribe(res => {
          res.messageType
            ? this.toaster.error(res.message)
            : this.projectFacade.clearEolPreReatil();
          this.toaster.success(res.message);
        });
    }
  }

  deletePackageEOLProject(data: any, path: any) {
    this.projectsService
      .deleteEolPreRetail(data.id, data.reuseFillingComponentDetailId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          path == 'preRetail' ? this.getPreRetailList() : this.getPostRetailList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  nextPage() {
    this.swalService
      .confirm('Scenario confirmation', 'Do you want to add another package scenario?')
      .then(async confirmed => {
        if (confirmed) {
          const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
          this.sharedService.navigateSiderbarMenu('isScenario'); // For routing directly to scenarios page
          this.router.navigate([
            `projects/projects-setting/${customEncode(btoa(encodedValue))}/scenario-list`,
          ]);
        } else {
          const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
          const isCheckReportNavigation = 'isCheckReportNavigation';
          this.sharedService.navigateSiderbarMenu(isCheckReportNavigation);
          const res = await this.sharedService.checkValidationForProductSector(
            this.activatedRouteProjectId
          );
          if (res.data.msg != '' && res.data.hasOwnProperty('msg')) {
            this.swalService
              .confirm('Report validation', res.data.msg, '', undefined, true)
              .then(confirmed => {
                if (confirmed) {
                } else {
                }
              });
          } else {
            this.router.navigate(
              [`projects/projects-setting/${customEncode(btoa(encodedValue))}/chart-at-glance`],
              { queryParams: { param: customEncode(btoa(encodedValue)) } }
            );
          }
        }
      });
  }

  findBackRoute() {
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.link == this.activatedRoute
    );
    const backIndex = activeIndex - 1;
    this.backRouteType = this.menuDataForRouting[backIndex].link;
  }

  backRoute() {
    this.findBackRoute();
    let valueToEncrypt;
    if (
      this.backRouteType === 'fill-data-list' ||
      this.backRouteType === 'wholesale-data-list' ||
      this.backRouteType === 'retail-list' ||
      this.backRouteType === 'consumer-list'
    ) {
      const id =
        this.backRouteType === 'fill-data-list' ||
        this.backRouteType === 'wholesale-data-list' ||
        this.backRouteType === 'retail-list' ||
        this.backRouteType === 'consumer-list'
          ? this.packageScenarioId
          : this.scenarioId;
      valueToEncrypt = `{ "id": ${id}, "packageScenarioId": ${id}, "eId": ${this.scenarioId}}`;
    } else {
      valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.scenarioId}}`;
    }
    const encryptedValue = encrypt(valueToEncrypt);
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${this.backRouteType}`],
      { queryParams: { param: encryptedValue } }
    );
  }

  updateIncorrectEolData() {
    this.swalService.confirm(UPDATE_SCENARIO_EOL_TITLE, UPDATE_SCENARIO_EOL).then(confirmed => {
      if (confirmed) {
        this.projectsService.updateIncorrectEOLRates(this.scenarioId).subscribe(res => {
          if (res.messageType) {
            this.toaster.error(res.message);
          } else {
            this.toaster.success(res.message);
            this.getAllEolData();
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    localStorage.removeItem('consumerEOL');
    localStorage.removeItem('retailEOL');
  }
}
